import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  constructor(private router: Router) {}

  currentUrl: string;

  ngOnInit() {
    this.currentUrl = this.router.url;
  }

  navigate(url: string) {
    this.router.navigate([url]);
  }
}
